<template>
  <el-form :model="ruleForm" status-icon :rules="loginFormRlue" ref="resetPasswordForm" class="forgetForm" label-position="top">
    <el-form-item prop="password">
      <el-input type="password" prefix-icon="icon-lock" size="medium" v-model.trim="ruleForm.password" :placeholder="$translate('newPasswordTips')"></el-input>
    </el-form-item>
    <el-form-item prop="confrimPass">
      <el-input prefix-icon="icon-lock" type="password" size="medium" v-model.trim="ruleForm.confrimPass" :placeholder="$translate('newPasswordConfirmTips')"></el-input>
    </el-form-item>
    <el-form-item label="">
      <el-button type="primary" class="retrieve-btn" style="width: 100%;" size="medium" :loading="loading" @click="loginSubmit">
        {{ $translate('confirmChange') }}
      </el-button>
    </el-form-item>
  </el-form>
</template>
<script>
import { encrypt } from "../../../utils/encrypt";
export default {
  data() {
    let validatePass = (rule, value, callback) => {
      if (value === '') {
        callback(new Error(this.$translate('newPasswordConfirmTips')));
      } else if (value !== this.ruleForm.password) {
        callback(new Error(this.$translate('inputPasswordNoSame')));
      } else {
        callback();
      }
    }
    return {
      loading: false,
      loginFormRlue: {
        password: [
          { required: true, message: this.$translate('newPasswordTips'), trigger: 'blur' },
          { min: 6, message: this.$translate('passwordLength'), trigger: 'blur' }
        ],
        confrimPass: [
          { validator: validatePass, trigger: 'blur' }
        ]
      },
      ruleForm: {
        password: '',
        confrimPass: ''
      },
      loginloading: true,
      systemName: "",
      bgImg: ""
    };
  },
  methods: {
    goToLogin() {
      let type = this.$route.query.loginmode || '';

      const {appName, adminName} = this.$store.state;

      const url = this.$getOrigin();

      let originName = `/${appName}/#/login`

      if (type == 'admin') {
        originName = `/${adminName}/#/`
      }

      if (type == 'mobile') {
        originName = "/mobile/#/login"
      }

      location.href = url + originName;
    },
    loginSubmit() {

      let _this = this;
      _this.$refs.resetPasswordForm.validate(valid => {
        if (valid) {
          _this.loading = true;

          let code = _this.$route.query.code || '';
          if (!code) {
            this.statusMsg(this.$translate('notGetCode'), "warning");
            return
          }
          let params = {
            "password": encrypt(_this.ruleForm.password),
            "confirmPassword": encrypt(_this.ruleForm.confrimPass),
            "code": code
          }
          _this.$api.Access.ResetPassword(params).then(res => {
            if (res && res.isSuccess) {
              if (res.data.isSuccess) {
                _this.$message({
                  type: 'success',
                  message: res.data.message + ',' + this.$translate("pReLogin"),
                  onClose: () => {
                    _this.goToLogin()
                  }
                })
              }else {
                _this.$message({
                  type: 'warning',
                  showClose: true,
                  message: res.data.message || this.$translate("submitFailed"),
                })
              }
            }
            _this.loading = false;
          })
        }
      })
    }
  }
};
</script>